import { useTranslation } from "react-i18next"
import FormField from "../../form/FormField"
import SelectInput from "../../form/SelectInput"
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import { setYear } from "../../../store/slices/accountingReportSlice";

export default function AccountingReport () {

  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const { year } = useAppSelector(state => state.reportSlice)

  return (
    <div>
      <div className="p-4 text-slate-600">
        {t('accountReport.text')}
      </div>

      <div className="px-4">
        <FormField className="mt-2 mb-6" label="Anno">
          <SelectInput
            value={{ label: year, value: year }}
            onChange={(val: any) => {
              dispatch(setYear(val.value))
            }}
            options={[
                { label: '2024', value: 2024 },
                { label: '2025', value: 2025 }
            ]}
          />
        </FormField>
      </div>
    </div>
  )

}
